export const AMENDCONTRACT_ERROR = 'AMENDCONTRACT_ERROR';
export const GET_AMENDCONTRACTTEAM = 'GET_AMENDCONTRACTTEAM';
export const GET_AMENDCONTRACTTEAMEXPORT = 'GET_AMENDCONTRACTTEAMEXPORT';
export const GET_AMENDCONTRACTDETAILS = 'GET_AMENDCONTRACTDETAILS';
export const GET_AMENDCONTRACT_DETAILS_EXPORT = 'GET_AMENDCONTRACT_DETAILS_EXPORT';
export const GET_AMENDMENTREASON = 'GET_AMENDMENTREASON';
export const SAVE_AMENDCONTRACT = 'SAVE_AMENDCONTRACT';
export const DELETE_AMENDCONTRACT = 'DELETE_AMENDCONTRACT';
export const AMENDCONTRACT_ADD_UPDATE = 'AMENDCONTRACT_ADD_UPDATE';
export const AMENDCONTRACT_CLEAR_ALL_UPDATES = 'AMENDCONTRACT_CLEAR_ALL_UPDATES';
export const AMENDCONTRACT_CLEAR = 'AMENDCONTRACT_CLEAR';
